var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_144_28)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_144_28",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_144_28",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_144_28",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACK0lEQVR4nO3dPW7UUBTF8ROKABIbIOwwfJRkByDRUFBRsQcKxAoCFBA2gYREBRMUUf2RJUeCKIyfPWPPmcP99X7z7pFle/yunqVSSimllFJKSQDcBB4B74Fz9sd5P+cHwKGcAfeAz+y/s64WGZ/JCSFf+mR5ZveXizT35Qb4QJ53cgOsyLOSG0LJDaHkhlByQyi5IZTcEEpuCCU3hJIbQskNoeSGUHJDKLkhlNwQSm4IJTeEUlvtt4GX/QLvN+BZt7RXQY/QWHsX8lVvZgmbUBqu+2DN6tL2wyaU2mr/sWaI7YZNKLXV/nxgmO2FTSi197R0Yc4fNqHUXv8h8HpguLfArQr6GiMzmD9sQml8DvOGTShNy2K+sAmliWYLm1DawCxhs6xfwGPgaJMgjOpqf/RjWSdzB7yDup66Tahzd/aEl6/rq9uEWOKSsYO6vrhNKPXS8cRtQpc3w5O6GQbRf/54txirkCvov9Vf8Akm5FAvlaawCrmCVr3431Rj7bWUtanG2l8MDFOLs0Ma6r4B/FwzRLUbbDHoi38cXg00rRprf3XNodUSNkZj7Xf6sC/69rCuoaaaHMcYmcHBLOFe+ZFIckMouSGU3BBKbgglN4SSG0LJDaHkhlByQyi5IZTcEEpuCCU3hJKb0E1gv8tNv217mlO5AR6S51hu+t6Gbm/8FB8tt57/42MKZyEhH8lZ3xrVfWLjdM9ukKt+zse2Z3IppZRSSimlaEd+Azxb3ZdpIbjUAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutActive);
export default __webpack_public_path__ + "static/media/Logout-active.9470141120ff8a1a9daa8c49e6169964.svg";
export { ForwardRef as ReactComponent };